import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";

import Image from "next/image";
import Link from "next/link";

import AppLogo from "../../../public/assets/img/app-logo.png";
import AboutUs from "../../../public/assets/img/about-us.png";
import C2A from "../../../public/assets/img/how-can-we-help.png";
import Search from "../../../public/assets/img/SVGSearch.svg";
import FBicon from "../../../public/assets/img/facebook.png";
import IGicon from "../../../public/assets/img/instagram.png";
import Twittericon from "../../../public/assets/img/twitter.png";

const BookingSec = () => {
  return (
    <>
      {/* Booking CTA */}
      <section className="bg-blue-500 md:py-48 py-28">
        <div className="max-w-7xl mx-auto grid grid-cols-1 items-center md:px-10 sm:px-8 px-6">
          <div className="col-span-1">
            <h2 className="text-center lg:text-5xl text-4xl font-medium leading-10 text-white ">
              Book an appointment
            </h2>
            <p className="text-center lg:text-xl md:text-lg text-base text-white mb-10">
              We will continue to enhance individual and collective well-being
              for a mentally healthy Philippines!
            </p>
            <div className="text-3xl text-center">
              <Link href="/booking">
                <a className="btn btn-secondary font-CantoraOne rounded-full max-w-[250px] w-full px-8">
                  Let's Talk
                </a>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookingSec;
